// @flow
import React, {Component} from "react";
import {CardImg} from "reactstrap";
import {connect} from "react-redux";
import type {StoreState} from "../../../reducers/combinedReducers";
import _ from "lodash";


type BlobCardImgProps = {
    src: string,
    alt: string,
    onClick: () => any,
    className?: string,
    auth: string
};

type BlobCardImgState = {

    blob?: string
};

class BlobCardImg extends Component<BlobCardImgProps, BlobCardImgState> {

    constructor(props: BlobCardImgProps) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {

        let response = await fetch(this.props.src, {
            headers: {
                "Authorization": `Bearer ${this.props.auth}`
            }
        });
        const blob: Blob = await response.blob();
        this.setState({
            blob: URL.createObjectURL(blob)
        });
    }

    render() {
        if (this.state.blob) {

            return (

                <CardImg top src={this.state.blob} alt={this.props.alt} onClick={this.props.onClick} className={this.props.className}/>
            )
        } else {
            return null;
        }
    }
}

export default connect((state: StoreState) => ({auth: _.get(state, 'loginUser.jwt')}))(BlobCardImg);


// WEBPACK FOOTER //
// ./src/components/ebadge/photo/BlobCardImg.js